/** "PRACTICE — nothing here is real."
 *
 *  The practice environment is a pixel-for-pixel copy of the app pointed at a
 *  different database. That is the whole idea, and it is also the hazard:
 *  someone who cannot tell which one they are looking at will enter a real
 *  week's hours into the sandbox and lose them, or treat real payroll as a
 *  place to experiment.
 *
 *  So this is not dismissible and it does not scroll away. It costs a strip of
 *  screen on a phone, which is a real cost, and it is worth it.
 *
 *  Gated on a build-time variable production does not set, so in a production
 *  build this component returns null and Tailwind never even needs the classes.
 */
export default function PracticeBanner() {
    if (process.env.REACT_APP_PRACTICE_MODE !== "true") return null;

    return (
        <div
            role="status"
            className="sticky top-0 z-40 bg-brand-danger text-brand-bone text-center px-3 py-1.5
                       text-[11px] font-bold uppercase tracking-[0.2em] leading-tight"
            data-testid="practice-banner"
        >
            Practice — nothing here is real
        </div>
    );
}
